@import "../../variables.scss";

.readingList__wrapper {
  width: 96%;
  @media (max-width: $size-md) {
    width: 100%;
  }
}
.button__wrapper {
  width: 98%;
  @media (max-width: $size-lg) {
    width: 96%;
  }
}